import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LandingPageResponseDto } from '@campaigns/data-access';
import { SKIP_ERROR_TOAST } from '@core-utils';
import {
  LoyaltySessionDto,
  PromoCustomerDto,
  SyncPromoCustomerDto,
  UpdatePromoCustomerDto,
} from '../dto';

@Injectable()
export class LandingPublicApiService {
  private http = inject(HttpClient);

  private route = 'promos';

  getLandingPage(
    campaignId: string,
  ): Observable<LandingPageResponseDto | null> {
    return this.http.get<LandingPageResponseDto | null>(
      `${this.route}/landing-page/${campaignId}`,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) },
    );
  }

  syncCustomer(body: SyncPromoCustomerDto): Observable<boolean> {
    return this.http.post<boolean>(`${this.route}/customers/sync`, body, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }

  getCurrentCustomer(): Observable<PromoCustomerDto> {
    return this.http.get<PromoCustomerDto>(`${this.route}/customers/me`, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }

  updateCurrentCustomer(body: UpdatePromoCustomerDto): Observable<void> {
    return this.http.put<void>(`${this.route}/customers/current`, body);
  }

  createLoyaltySession(): Observable<LoyaltySessionDto> {
    return this.http.post<LoyaltySessionDto>(
      `${this.route}/loyalty/session`,
      null,
    );
  }
}
